class CartDrawer extends HTMLElement {
  constructor() {
    super();
      
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

  }

  setHeaderCartIconAccessibility() {
    // Every header instance (new, old, and any future variant) shares the
    // `.head-cart-wrp` class on its cart link, so wire up all of them here
    // instead of a single hardcoded id - this keeps working no matter how
    // many header sections are rendered for the A/B test.
    const cartLinks = document.querySelectorAll('.head-cart-wrp');
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');

      if(window.location.pathname != routes_cart_url ){
        cartLink.setAttribute('aria-haspopup', 'dialog');

        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink)

        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }
    });
  }

  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  
    //reload freeshiping price line, fro cart.js
   //fetchCart();
   
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    
   
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
      
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
      
  }

  setActiveElement(element) {
    this.activeElement = element;
    
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




if (!customElements.get('add-on-save-item')) {
customElements.define(
  'add-on-save-item',
  class addOnSaveItem extends HTMLElement {
    constructor(){
      super();

      this.addOnBtn = this.querySelector('.js-add-on-btn')

    }
    connectedCallback() {

      this.addOnBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentButton = e.currentTarget;
        const currentId = e.currentTarget.dataset.productid;
      
        const formData = {
          'items': [{
           'id': e.currentTarget.dataset.productid,
           'quantity': 1
           }]
         };
         
         fetch(window.Shopify.routes.root + 'cart/add.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(formData)
         })
         .then(response => {
           return response.json();
         })
         .catch((error) => {
           console.error('Error:', error);
         })
         .finally(() => {

          this.renderDrawerCart();
          updateCartCounterHeader();

         });

      })
    }


    renderDrawerCart(){

      fetch('/cart')
      .then(response =>  response.text())
      .then( data => {
        const html = new DOMParser().parseFromString(data, 'text/html');
        const cartDrawerNew = html.querySelector('cart-drawer .drawer__inner');

        document.querySelector('cart-drawer .drawer__inner').innerHTML = cartDrawerNew.innerHTML

         //item_count
       
         //fetchCart()
    
      }).finally(() => {
        updateCartCounterHeader();
      })
    }


  }
);
}


if (!customElements.get('drawer-promo-code')) {
customElements.define(
  'drawer-promo-code',
  class drawerPromoCode extends HTMLElement {
    constructor(){
      super();

      this.toggleButton = this.querySelector('.js-promo-toggle')
      this.drawerPromoInput = this.querySelector('.js-promo-input-wrp')

    }
    connectedCallback() {
      this.drawerPromoInput.style.display = 'none';
 
      this.toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.drawerPromoInput.style.display = this.drawerPromoInput.style.display === 'none' ? 'flex' : 'none';
      })
    }

  }
);
}



if (!customElements.get('remove-addon')) {
customElements.define(
  'remove-addon',
  class removeAddon extends HTMLElement {
    constructor(){
      super();

      

    }
    connectedCallback() {

      this.addEventListener('click', (e) => {
        e.preventDefault();

        const removeId = e.currentTarget.dataset.productid;

        let updates = {
          [removeId]: 0
        };
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
            document.querySelector('add-on-save-item').renderDrawerCart();
        })
        
      })
     
     

    }

  }
);
}
